module.exports = __webpack_public_path__ + "static/media/jane_logo.d5a0ad7a.png";